import React from 'react';
import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';
import './editor.scss';

export default function Edit({attributes, setAttributes}) {
	return (
		<>
			<div { ...useBlockProps() } >
				<div className='casaca-blocks-page'>
					<InnerBlocks />
				</div>
			</div>
		</>
	);
}
